module.exports = __webpack_public_path__ + "static/media/dog.dce15f4f.svg";